import {
  ADULT_CAN_ONLY_BUY_REC_MESSAGE,
  CONFIRM_RESET_CART_MESSAGE,
  CONFIRM_RESET_CART,
  CANCEL_RESET_CART,
  SAME_SALES_CHANNEL_MESSAGE
} from '../const/cart_const';

export const adultCanOnlyBuyRecModalProps = () => ({ message: ADULT_CAN_ONLY_BUY_REC_MESSAGE });
export const cannotMixItemsFromDifferentSalesChannelsModalProps = () => ({ message: SAME_SALES_CHANNEL_MESSAGE });

export const confirmResetCartModalProps = (confirm) => {
  return {
    title: 'WARNING',
    message: CONFIRM_RESET_CART_MESSAGE,
    confirmText: CONFIRM_RESET_CART,
    cancelText: CANCEL_RESET_CART,
    confirm: () => {
      if (confirm) {
        confirm();
      }
    }
  }
}

export const confirmResetCartModal = (confirm, message) => {
  return {
    title: 'WARNING',
    message,
    confirmText: CONFIRM_RESET_CART,
    cancelText: CANCEL_RESET_CART,
    confirm: () => {
      if (confirm) {
        confirm();
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/helpers/cartHelper.js